import {I18n} from '@aws-amplify/core';

import {formatTimestamp} from '../../../utils/TableTimestamps';
import {NavLink} from 'react-router-dom';
import {Account, AccountStatus} from '../types';
import {AccountStatusBadge} from '../profile/AccountStatusBadge';
import {AccountTypeBadge} from '../profile/AccountTypeBadge';

// FNP-383: days remaining in the 30-day soft-delete retention window.
// Computed from scheduledHardDeleteAt (set by the FNP-281 soft-delete
// resolver) minus now. Returns null on non-PENDING_DELETION rows or when
// the field is missing. Clamped at 0 so an already-overdue row reads "0"
// rather than a negative.
const daysRemaining = (item: Account): number | null => {
    if (item.accountStatus !== AccountStatus.PENDING_DELETION) {
        return null;
    }
    if (!item.scheduledHardDeleteAt) {
        return null;
    }
    const scheduled = new Date(item.scheduledHardDeleteAt).getTime();
    if (Number.isNaN(scheduled)) {
        return null;
    }
    const diffMs = scheduled - Date.now();
    if (diffMs <= 0) {
        return 0;
    }
    return Math.ceil(diffMs / (1000 * 60 * 60 * 24));
};

export const columns = [
    {
        title: I18n.get('Account'),
        width: '1fr',
        render: (item: Account) => <NavLink to={`/accounts/${item.id}`}>{item.email}</NavLink>,
    },
    {
        title: I18n.get('SUB'),
        width: '1fr',
        render: (item: Account) => item.sub,
    },
    {
        title: I18n.get('Username'),
        width: '1fr',
        render: (item: Account) => item.username,
    },
    {
        title: I18n.get('Account Type'),
        width: '1fr',
        render: (item: Account) => <AccountTypeBadge record={item}/>,
    },
    {
        title: I18n.get('Status'),
        width: '1fr',
        render: (item: Account) => <AccountStatusBadge record={item}/>,
    },
    {
        title: I18n.get('Days Remaining'),
        width: '1fr',
        render: (item: Account) => {
            const days = daysRemaining(item);
            return days === null ? '' : `${days}`;
        },
    },
    {
        title: I18n.get('Created'),
        width: '1fr',
        render: (item: Account) => formatTimestamp(item.created as string),
    },
];
